import { Link } from "react-router-dom";
import { isSuperAdmin } from "./adminApi";
import "./admin.css";

export default function AdminLayout({ session, title, backTo, children }) {
  const superAdmin = isSuperAdmin(session);

  return (
    <div className="adm-bg">
    <header className="adm-header">
      <div className="adm-brand">
        <div
          className="adm-brand-logo"
          onClick={() => { window.location.href = process.env.REACT_APP_BASE_URL; }}
        >
          <img src={process.env.REACT_APP_EM_LOGO} alt="Extramile Play" />
          {superAdmin && " SUPERADMIN"}
        </div>
        <div>Easter Candy Crush</div>
      </div>
      <div className="adm-user">
        <img src="/admin/user.png" alt="" />
      </div>
    </header>
    <div className="adm-page">
      <div className="adm-topbar">
        <div className="adm-topbar-left">
          {backTo && (
            <Link to={backTo} className="adm-back">&laquo; BACK</Link>
          )}
          <h1 className="adm-title">
            {title}
            {superAdmin && <span className="adm-badge">Superadmin</span>}
          </h1>
        </div>
      </div>
      {children}
    </div>
    </div>
  );
}
